import React, { Component } from 'react';
import PropTypes from 'prop-types';

class CheckoutTimer extends Component {
    render() {
        let content = <span><strong>{this.props.time}</strong> left to complete order</span>;

        if(this.props.condensed === false) {
            content = <span>You have <strong>{this.props.time}</strong> left to complete your order</span>;
        }

        return(
            <div className="cart__reservation-time">
                <div className="checkout-timer">
                    {content}
                </div>
            </div>
        )
    }
}

CheckoutTimer.propTypes = {
    condensed: PropTypes.bool,
    time: PropTypes.string.isRequired
}

export default CheckoutTimer;
